import Common from "./common";
import DataTypes from "./dataTypes";
import Error from "./error";
import Format from "./format";

export const Utility = {
	Common,
	Error,
	Format,
	DataTypes,
};
